export const WorkloadConfig = {
    name            : 'Workload',
    menuName        : 'Workload',
    icon            : 'i5-timeline',
    // iconLight       : 'i5-workload-light',
    image           : 'workload',
    iconSvg         : 'isvg-view-workload',
    url             : 'workload',
    stringId        : 'workload',
    proOnly         : true,
    description     : 'View and manage the team\'s workload, allocate resources, and schedule work items.',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_WORKLOAD_CONFIG = {
    ...WorkloadConfig,
    // key2: "newValue2",  // Replacing the value for key2
}